import "core-js/modules/es.number.to-fixed.js";
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-e8c2b24a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "d-flex fl-start"
};
var _hoisted_2 = {
  class: "d-flex fl-s-b"
};
var _hoisted_3 = {
  class: "d-flex fl-s-b"
};
var _hoisted_4 = {
  class: "d-flex fl-s-b"
};
var _hoisted_5 = {
  class: "w-50"
};
var _hoisted_6 = {
  class: "final-info"
};
var _hoisted_7 = {
  class: "total-info"
};
var _hoisted_8 = {
  class: "d-flex fl-ev"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_header = _resolveComponent("el-header");

  var _component_el_aside = _resolveComponent("el-aside");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_main = _resolveComponent("el-main");

  var _component_el_divider = _resolveComponent("el-divider");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_footer = _resolveComponent("el-footer");

  var _component_el_container = _resolveComponent("el-container");

  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_header, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
            class: _normalizeClass(["discount-quantity-btn", {
              'w-100': _ctx.discountInfo.type === 2,
              'w-50': _ctx.discountInfo.type === 1,
              'choosen-all-green': _ctx.discountInfo.isOnAllOrder,
              'choosen-some-grey': !_ctx.discountInfo.isOnAllOrder
            }]),
            onClick: _ctx.makeDiscountOnAllOrder
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("discount.all-order")), 1)];
            }),
            _: 1
          }, 8, ["class", "onClick"]), _ctx.discountInfo.type === 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: _normalizeClass(["discount-quantity-btn w-50", {
              'choosen-some-grey': _ctx.discountInfo.isOnAllOrder,
              'choosen-all-green': !_ctx.discountInfo.isOnAllOrder
            }]),
            onClick: _ctx.UpdateDiscountApplicationCoverage
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("discount.specific-tickets")), 1)];
            }),
            _: 1
          }, 8, ["class", "onClick"])) : _createCommentVNode("", true)])];
        }),
        _: 1
      }), _createVNode(_component_el_container, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_aside, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                class: _normalizeClass(["discount-type-btn", {
                  'active-btn': _ctx.discountInfo.type === 1
                }]),
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.updateDiscountType(_ctx.DiscountTypes.Percentage_Discount);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("discount.choose-percentage").toUpperCase()), 1)];
                }),
                _: 1
              }, 8, ["class"]), _createVNode(_component_el_button, {
                class: _normalizeClass(["discount-type-btn", {
                  'active-btn': _ctx.discountInfo.type === 2
                }]),
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.updateDiscountType(_ctx.DiscountTypes.Fixed_Value_Discount);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("discount.choose-fixed-value").toUpperCase()), 1)];
                }),
                _: 1
              }, 8, ["class"])];
            }),
            _: 1
          }), _createVNode(_component_el_container, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_main, null, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 5
                    }]),
                    onClick: _cache[2] || (_cache[2] = function ($event) {
                      return _ctx.updateDiscountValue(5);
                    }),
                    "data-cy": "discount-5"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "5%" : _ctx.currency + " 5"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"]), _createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 10
                    }]),
                    onClick: _cache[3] || (_cache[3] = function ($event) {
                      return _ctx.updateDiscountValue(10);
                    }),
                    "data-cy": "discount-10"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "10%" : _ctx.currency + " 10"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"]), _createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 15
                    }]),
                    onClick: _cache[4] || (_cache[4] = function ($event) {
                      return _ctx.updateDiscountValue(15);
                    })
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "15%" : _ctx.currency + " 15"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 30
                    }]),
                    onClick: _cache[5] || (_cache[5] = function ($event) {
                      return _ctx.updateDiscountValue(30);
                    }),
                    "data-cy": "discount-30"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "30%" : _ctx.currency + " 30"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"]), _createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 50
                    }]),
                    onClick: _cache[6] || (_cache[6] = function ($event) {
                      return _ctx.updateDiscountValue(50);
                    }),
                    "data-cy": "discount-50"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "50%" : _ctx.currency + " 50"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"]), _createVNode(_component_el_button, {
                    class: _normalizeClass(["discount-value-btn", {
                      'active-btn': _ctx.discountInfo.value === 100
                    }]),
                    onClick: _cache[7] || (_cache[7] = function ($event) {
                      return _ctx.updateDiscountValue(100);
                    }),
                    "data-cy": "discount-100"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.discountInfo.type === 1 ? "100%" : _ctx.currency + " 100"), 1)];
                    }),
                    _: 1
                  }, 8, ["class"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
                    class: "calc-btn",
                    onClick: _ctx.showCalculator
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_SvgIcon, {
                        iconContent: _ctx.calcIcon,
                        iconAlt: _ctx.calcAlt,
                        iconStyle: _ctx.calcIconStyle
                      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
                    }),
                    _: 1
                  }, 8, ["onClick"])])];
                }),
                _: 1
              }), _createVNode(_component_el_footer, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_divider), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
                    type: "flex",
                    justify: "start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("button.discount")), 1)];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("span", null, _toDisplayString(_ctx.currency), 1)];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6,
                        class: "d-flex fl-j-e"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("span", null, _toDisplayString((_ctx.discountResult / 100).toFixed(2)), 1)];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }), _createVNode(_component_el_row, {
                    type: "flex",
                    justify: "start"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_col, {
                        span: 12
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("completeorder.order-total")), 1)];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("p", null, _toDisplayString(_ctx.currency), 1)];
                        }),
                        _: 1
                      }), _createVNode(_component_el_col, {
                        span: 6,
                        class: "d-flex fl-j-e"
                      }, {
                        default: _withCtx(function () {
                          return [_createElementVNode("span", null, _toDisplayString(_ctx.total), 1)];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
                    class: "apply-btn mr-10 ml-10",
                    onClick: _ctx.applyDiscount2,
                    "data-cy": "apply-discount-button"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.$t("promocode.apply")), 1)];
                    }),
                    _: 1
                  }, 8, ["onClick"]), _createVNode(_component_el_button, {
                    class: _normalizeClass(['apply-btn', _ctx.isDiscountApplied ? 'color-red' : 'color-gray']),
                    disabled: !_ctx.isDiscountApplied,
                    onClick: _ctx.refreshDiscount,
                    "data-cy": "remove-discount-button"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_ctx.$t("common.remove")), 1)];
                    }),
                    _: 1
                  }, 8, ["class", "disabled", "onClick"])])])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  });
}